<script setup>
import {ref} from 'vue';
import Faq from '@/Components/Public/Cards/Faq.vue';

const props = defineProps({
    faq_subjects: Array,
    is_first: Boolean,
});

const openId = ref(props.faq_subjects[0]?.faqs[0]?.id);
</script>

<template>
    <div
        class="container mb-15 mt-8 md:mb-30"
        :class="{'md:mt-30': !is_first}"
    >
        <template
            v-for="subject in faq_subjects"
            :key="subject.id"
        >
            <h2
                class="my-8 text-8 font-extrabold md:mb-8 lg:mt-16 lg:text-10 xl:text-10 xl:leading-12"
            >
                {{ subject.name }}
            </h2>
            <div class="grid flex-1 gap-4">
                <Faq
                    v-for="faq in subject.faqs"
                    :key="faq.id"
                    v-model="openId"
                    :faq="faq"
                />
            </div>
        </template>
    </div>
</template>
